module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gg"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'gg',
        params: {
          nr: 'gsgg'
        }
      }
    }
  }, [_vm._v("公司公告")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'gg',
        params: {
          nr: 'jys'
        }
      }
    }
  }, [_vm._v("交易所公告")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'gg',
        params: {
          nr: 'bzj'
        }
      }
    }
  }, [_vm._v("保证金公告")])], 1), _vm._v(" "), _c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.nr == 'gsgg'),
      expression: "$route.params.nr=='gsgg'"
    }],
    attrs: {
      "list": _vm.gsgg,
      "name": "gsgg"
    }
  }), _vm._v(" "), _c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.nr == 'jys'),
      expression: "$route.params.nr=='jys'"
    }],
    attrs: {
      "list": _vm.jys,
      "name": "jys"
    }
  }), _vm._v(" "), _c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.nr == 'bzj'),
      expression: "$route.params.nr=='bzj'"
    }],
    attrs: {
      "list": _vm.bzj,
      "name": "bzj"
    }
  }), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("公告")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-186db085"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/gg/gg.vue
// module id = 806
// module chunks = 2